export enum SingleMeasurmentQueryKeys {
  GetAllBatches = 'GET_ALL_BATCHES',
  GetTaskImage = 'GET_TASK_IMAGE',
  GetABatch = 'GET_A_BATCH',
}
